import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { Search } from '../../../shared/user.model';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { RegistrationService } from '../../../registration.service';


@Component({
  selector: 'app-office-grid',
  templateUrl: './office-grid.component.html',
  styleUrls: ['./office-grid.component.css']
})
export class OfficeGridComponent implements OnInit {
  maintitle="Office";
  title = "View Office";
  s: Search;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  totalItems: number;
  officeList;
  isSearch: boolean;
  message:boolean;
  searchdetails:any={};
  data: any;
  DistrictList: any;
  office:any={};
  districtid: any;
  officeid: any;
  officeDistrictList:any={};
  Offdistict: any;
  constructor(private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) {
    this.s = new Search();
    this.isSearch = false;
  }

  ngOnInit() {
    this.GetAllOffices(this.itemsPerPage, 1);
    this.GetAllDistrictNames();
  }


  SetUrl(officeId:any,mode:any)
  {
    localStorage.setItem('officeId',officeId);
    localStorage.setItem('mode', mode);
  }

  pageChanged(pageNumber: number) {
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
    else
      this.GetAllOffices(this.itemsPerPage, pageNumber);
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNo);
    else
      this.GetAllOffices(this.itemsPerPage, pageNo);
  }
  GetAllDistrictNames() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllDistrictNames();
    this.data.subscribe(
      (response) => {
        this.DistrictList = response;
        document.getElementById('loader-spinner').style.display = "none";
        
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }


  GetDistrictNamesListGrid(districtid) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllDistrictNamesListgrid(districtid);
    this.data.subscribe(
      (response) => {
        this.officeDistrictList = response;
        document.getElementById('loader-spinner').style.display = "none";
        
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  GetAllOffices(itemsPerPage: number, pageNo: number) {
    this.message=false;
    this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllOffices(itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.officeList = data.OfficeModels;
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  ActivateInactivateOffices(id: string, inActive: string) {
    if (inActive == 'N') {
     
         
    swal({
        title: 'Are you sure?', text: "You want to inactivate!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, inactivate it!'
      }).then((result) => {
        if (result.value) {
          this.data = this.userService.GetAllDistrictNamesListgrid2(id);
          this.data.subscribe(
            (response: any) => {
              this.Offdistict = response.Result;
              var offc=this.officeDistrictList.length;
              if(offc==0)
              {
          this.ActivateInactivateOffice(id, inActive);
              }
              else{
          
                swal('Warning!', 'You have to Delete releated District details in this particular Office.', 'warning');
                return
              }
            })
        }
      })
    
  }
    else {
      swal({
        title: 'Are you sure?', text: "You want to activate!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, activate it!'
      }).then((result) => {
        if (result.value) {
          this.ActivateInactivateOffice(id, inActive);
        }
      })
    }
  }

  ActivateInactivateOffice(id: string, inActive:string) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.activateInactivateOffices(id)
      .subscribe(
        (data) => {
          this.GetAllOffices(this.itemsPerPage, 1);
          document.getElementById('loader-spinner').style.display = "none";
          if(inActive=='N')
          swal('Inactivated!', 'Office has been inactivated.', 'success');
          else
          swal('Activated!', 'Office has been activated.', 'success');
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 400)
          swal('Warning!', 'Please delete all users belonging to this office.','warning');
          //this.errorHandler.HandlerError(error);
        });
  }

  onSearch(s, itemsPerPage: number, pageNo: number) {
    this.isSearch = true;
    let searchText = this.s.SearchText;
    let searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
      swal("Warning!", "Please enter the search criteria and search text.", "warning");
    else {
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.searchOffices(searchCriteria, searchText, itemsPerPage, pageNo,this.searchdetails)
        .subscribe(
          (data: any) => {
            if(data.OfficeModels.length!=0){
              this.message=false;
            this.officeList = data.OfficeModels;
            this.totalItems = data.TotalItemsCount;
            this.currentPage = pageNo;
            document.getElementById('loader-spinner').style.display = "none";
          }
          else
          {
          document.getElementById('loader-spinner').style.display = "none";
          this.message=true;
          }
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            //swal('Search Failed.');
            this.errorHandler.HandlerError(error);
          });
    }
  }


  getids(DI_District,id)
{
  debugger;
  
  this.districtid=DI_District;
  this.officeid=id;
 this.GetDistrictNamesListGrid(this.districtid);
}
 
AddsubDistrict(office)
{
 
  debugger;
  document.getElementById('loader-spinner').style.display = "block";
  this.office.Office_ID_FK=this.officeid;
  this.office.OfficeDI_ID_FK=this.districtid;
  this.userService.CreateOfficeDistrict(office)
    .subscribe(
      (data) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Saved Successfully!','success');
        this.GetDistrictNamesListGrid(this.districtid);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        //this.errorHandler.HandlerError(error);
        swal('Warning!', error.error.Message, 'warning');
      });
      this.GetDistrictNamesListGrid(this.districtid);
      // this.GetAllOffices(this.itemsPerPage, 1);
   
    
}


deltetegridoffcdistrictlist(DI_Id)
{
  debugger;

document.getElementById('loader-spinner').style.display = "block";
this.userService.dleteOffcdistrict(DI_Id)
  .subscribe(
    (data) => {
      this.GetDistrictNamesListGrid(this.districtid);
      document.getElementById('loader-spinner').style.display = "none";
     
      swal('Deleted!', 'Office District has been Deleted.', 'success');      
    }, (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      if (error.status == 400)
      swal('Warning!', 'Please delete all users belonging to this office.','warning');
      //this.errorHandler.HandlerError(error);
    });
}


}



// WEBPACK FOOTER //
// ./src/app/ultilities/office/office-grid/office-grid.component.ts